import { UserRoleEnum } from 'core/enums';

export interface PasswordSetupTokenViewModel {
    isValid: boolean;
    message: string | null;
    login: string | null;
    roles?: Array<UserRoleEnum | string> | null;
}

export interface SetPasswordByTokenReqModel {
    token: string;
    password: string;
}

export interface SetPasswordResultViewModel {
    success: boolean;
    roles?: Array<UserRoleEnum | string> | null;
    message: string | null;
}

export enum AppUserPasswordSetupTokenTypeEnum {
    InitialPasswordSetup = 1,
    AdminPasswordReset = 2,
}

export interface AppUserPasswordSetupTokenListItem {
    id: number;
    tokenType: AppUserPasswordSetupTokenTypeEnum;
    createDate: string;
    expiresAt: string;
    usedAt?: string | null;
    createUserName?: string | null;
}

export interface AppUserPasswordSetupTokenListRequest {
    appUserId: number;
    page?: number;
    pageSize?: number;
    orderBy?: string;
    reverse?: boolean;
}

export interface AppUserPasswordSetupTokenListResponse {
    data: AppUserPasswordSetupTokenListItem[];
    totalCount: number;
}

export interface PasswordPolicyViolationError {
    error?: string;
    error_description?: string;
    details?: {
        failedRules?: string[];
    };
}

export interface ExpiredPasswordLoginError {
    error?: string;
    error_description?: string;
    ErrorCode?: string;
    code?: string;
    Code?: string;
    message?: string;
    Message?: string;
    reason?: string;
    Reason?: string;
    isPasswordExpired?: boolean;
    IsPasswordExpired?: boolean;
    token?: string;
    Token?: string;
    passwordSetupToken?: string;
    PasswordSetupToken?: string;
    changePasswordToken?: string;
    ChangePasswordToken?: string;
    passwordChangeToken?: string;
    PasswordChangeToken?: string;
    passwordResetToken?: string;
    PasswordResetToken?: string;
    resetPasswordToken?: string;
    ResetPasswordToken?: string;
}
